// src/utils/headerLinks.js

export const getHeaderLinks = (userStatus, planId, role) => {
  const guestLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About Us' },
    { to: '/how-it-works', label: 'How It Works' },
    { to: '/pricing', label: 'Free Trial' },
    { to: '/requests', label: 'Next Drops' },
    { to: '/contact', label: 'Contact Us' },
    { to: '/faq', label: 'FAQ' },
    { to: '/login', label: 'Login' }
  ];

  if (userStatus === 'guest') {
    return guestLinks;
  }

  const commonLinks = [
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/browse', label: 'Browse Music' },
    { to: '/requests', label: 'Next Drops' }
  ];

  if (userStatus === 'verified') {
    return [
      ...commonLinks,
      { to: '/student-onboarding', label: 'Set Preferences' },
      { to: '#logout', label: 'Logout' }
    ];
  }

  const defaultRoleLinks = [
    { to: '/playlists', label: 'Playlists' },
    { to: '/settings', label: 'Settings' },
    { to: '#logout', label: 'Logout' }
  ];

  const adminRoleLinks = [
    { to: '/admin', label: 'Admin' },
    ...defaultRoleLinks
  ];

  const roleBasedLinks = {
    student: defaultRoleLinks,
    parent: defaultRoleLinks,
    teacher: defaultRoleLinks,
    administrator: defaultRoleLinks,
    creator: defaultRoleLinks,
    admin: adminRoleLinks
  };

  if (userStatus === 'complete') {
    const userRoleLinks = roleBasedLinks[role?.toLowerCase()] || defaultRoleLinks;
    return [...commonLinks, ...userRoleLinks];
  }

  return guestLinks;
};
